import mochi from '../../../../domain/assets/loadingMochi.svg';
import styles from './index.module.scss';

const SpinnerMochi = () => (
  <div
    className={styles.spinner}
    style={{ WebkitMaskImage: `url(${mochi})`, maskImage: `url(${mochi})` }}
  />
);
export default SpinnerMochi;
